import { useTranslation } from 'next-i18next';
import { useAirportsWidgetState } from '../../../../../components/SearchForm/components/AirportsWidget/hooks/useAirportsWidgetState.js';
export const useAirportsLabel = ({
  airports,
  config,
  forcedNeutralLabel,
  useLongLabels = false,
  primaryCountry
}) => {
  const {
    t
  } = useTranslation();
  const {
    isAllChecked,
    retrieveCheckedRegions,
    retrieveExtraCodes
  } = useAirportsWidgetState({
    value: airports || [],
    airports: config
  });
  if (forcedNeutralLabel && airports?.length === 0) {
    return forcedNeutralLabel;
  }
  if (isAllChecked()) {
    return t('searchForm:airportsField.allAirportsLabelShort');
  }
  const checkedRegions = retrieveCheckedRegions();
  const extraCodes = retrieveExtraCodes(checkedRegions);
  const nameVariant = useLongLabels ? 'name' : 'nameShort';
  const labelParts = [];
  if (checkedRegions.length > 0) {
    labelParts.push(...Object.entries(checkedRegions.reduce((accumulator, {
      region,
      subRegion
    }) => ({
      ...accumulator,
      [region]: subRegion ? [...(accumulator[region] || []), subRegion] : []
    }), {})).sort(([region]) => region === primaryCountry ? -1 : 1).map(([region, subRegions]) => {
      const regionName = t(`airportsWidget:options.${region}.${nameVariant}`);
      if (subRegions.length === 0) {
        return `${regionName} (${t(`airportsWidget:options.all.${nameVariant}`)})`;
      }
      const subRegionList = subRegions.map(subRegion => t(`airportsWidget:options.${subRegion}.name`)).join(', ');
      return `${regionName} (${subRegionList})`;
    }));
  }
  const individualAirports = extraCodes.length > 3 ? t('searchForm:airportsField.xAirports', {
    count: extraCodes.length
  }) : extraCodes.join(', ');
  if (labelParts.length === 0 && !individualAirports) {
    return t('searchForm:airportsField.anyAirportLabel');
  }
  return [labelParts.join(', '), individualAirports].filter(Boolean).join(' + ');
};